import digitalPrinting from "./templates/digital-printing";

export default [
  {
    id: `description`,
    title: `О товаре`,
  },
  {
    id: `material`,
    title: `Описание`,
    content: {
      description: `
        <p>Коробка-пенал с индивидуальным дизайном состоит из 2-х частей: футляр (внешний рукав) и ящик-поддон, который вставляется в этот футляр. Такая упаковка отлично подходит для небольших предметов, например, футболок. В конструкции коробки используется самый качественный картон различной плотности. Индивидуальный дизайн наносится с помощью цифровой печати. Заказ от 1 шт.</p>
        <p>Размеры: 190х270х33 мм.</p>
      `
    }
  },
  {
    id: `printing`,
    title: `Способ печати`,
    content: {
      printingInfo: `${digitalPrinting}`
    }
  },
  {
    id: `price`,
    title: `Цены`
  },
  {
    id: `delivery`,
    title: `Доставка и оплата`
  },
  {
    id: `reviews`,
    title: `Отзывы`
  }
];
